
import * as defaultImport from "@splunk/visualization-context/ImageContext";
export * from "@splunk/visualization-context/ImageContext";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
